import { defineMessages } from 'react-intl';

export const scope = 'connectors';

export default defineMessages({
    connector_name_exist: {
        id: `${scope}.connector_name_exist`,
        defaultMessage: 'Integration name is already in use.',
    },
    connector_success: {
        id: `${scope}.connector_success`,
        defaultMessage: 'Connector added successfully.',
    },
    integration_update_success: {
        id: `${scope}.integration_update_success`,
        defaultMessage: 'Connector updated successfully.',
    },
    integration_update_error: {
        id: `${scope}.integration_update_error`,
        defaultMessage: 'Failed to update connector.',
    },
    invalid_connector: {
        id: `${scope}.invalid_connector`,
        defaultMessage: 'Integration not found.',
    },
    connector_update_success: {
        id: `${scope}.connector_update_success`,
        defaultMessage: 'Authenticated successfully.',
    },
    connector_error: {
        id: `${scope}.connector_error`,
        defaultMessage: 'Failed to add connector.',
    },
    connector_update_error: {
        id: `${scope}.connector_update_error`,
        defaultMessage: 'Authentication failed.',
    },
    pop_up_block: {
        id: `${scope}.pop_up_block`,
        defaultMessage: 'A pop-up was blocked. Please allow pop-ups for this site.',
    },
    oauth_timeout: {
        id: `${scope}.oauth_timeout`,
        defaultMessage: 'OAuth process timed out. Please try again.',
    },
    connection_error: {
        id: `${scope}.connection_error`,
        defaultMessage: 'Connection failed. Please try again.',
    },
    oauth_cancel: {
        id: `${scope}.oauth_cancel`,
        defaultMessage: 'OAuth process was cancelled.',
    },
    unexpected_error: {
        id: `${scope}.unexpected_error`,
        defaultMessage: 'An unexpected error occurred. Please try again.',
    },
    option_error: {
        id: `${scope}.option_error`,
        defaultMessage: 'Please select at least one option.',
    },
    trigger_check: {
        id: `${scope}.trigger_check`,
        defaultMessage: 'Please delete all triggers for this integration and try again.',
    },
    integration_remove_success: {
        id: `${scope}.integration_remove_success`,
        defaultMessage: 'Integrations removed successfully.',
    },
    integration_remove_error: {
        id: `${scope}.integration_remove_error`,
        defaultMessage: 'Failed to remove integrations.',
    },
    integration_remove_check: {
        id: `${scope}.integration_remove_check`,
        defaultMessage: 'Are you sure you want to delete the integration',
    },
    trigger_name_exist: {
        id: `${scope}.trigger_name_exist`,
        defaultMessage: 'Trigger name is already in use.',
    },
    trigger_add_error: {
        id: `${scope}.trigger_add_error`,
        defaultMessage: 'Error adding trigger. Please try again.',
    },
    trigger_add_success: {
        id: `${scope}.trigger_add_success`,
        defaultMessage: 'Trigger added successfully.',
    },
    trigger_update_error: {
        id: `${scope}.trigger_update_error`,
        defaultMessage: 'Error updating trigger. Please try again.',
    },
    trigger_update_success: {
        id: `${scope}.trigger_update_success`,
        defaultMessage: 'Trigger updated successfully.',
    },
    trigger_delete_check: {
        id: `${scope}.trigger_delete_check`,
        defaultMessage: 'Are you sure you want to delete the trigger',
    },
    trigger_delete_error: {
        id: `${scope}.trigger_delete_error`,
        defaultMessage: 'Failed to delete trigger. Please try again.',
    },
    trigger_delete_success: {
        id: `${scope}.trigger_delete_success`,
        defaultMessage: 'Trigger removed successfully.',
    },
    source_token_error: {
        id: `${scope}.source_token_error`,
        defaultMessage: 'Your session has expired. Please reconnect to continue.',
    },
});
